module.exports = __webpack_public_path__ + "img/学校-未选中.7d5d1af1.png";